const observerLastRow = (
  observerContentRow: IntersectionObserver,
  hasNextPage: boolean,
  dataTestId: string
) => {
  if (!hasNextPage) return;

  const rows = document.querySelectorAll(`[data-testid="${dataTestId}"]`);

  if (rows.length === 0) return;

  const lastRow = rows[rows.length - 1];

  observerContentRow.observe(lastRow);
};

export function registerObserver(fetchCallback: Function, dataTestId: string) {
  const observerContentRow = new IntersectionObserver(
    async ([lastRow], observer) => {
      if (!lastRow.isIntersecting) return;

      observer.unobserve(lastRow.target);

      const hasNextPage = await fetchCallback();
      observerLastRow(observerContentRow, hasNextPage, dataTestId);
    }
  );

  observerLastRow(observerContentRow, true, dataTestId);
}
